export default __webpack_public_path__ + "static/media/500.b3a40d04.svg";